import React from 'react';
import { Box, Typography } from '@material-ui/core';
import { Opacity, LocalFlorist, Landscape, Nature } from '@material-ui/icons';

import { DiscreteProgressBarGroup } from 'src/components/progress/DiscreteProgressBarGroup';
import { generateSegments } from 'src/utils/aspectCategoriesUtils';
import PropTypes from 'prop-types';
import { WaterCheck } from 'src/utils/mdIcons';


const concernLevels = [
  { label: 'Proporción de vegetación natural', id: 'naturalVegetationCoverage', icon: <Landscape /> },
  { label: 'Integridad de los ecosistemas', id: 'ecosystemIntegrity', icon: <Nature /> },
  { label: 'Calidad de agua dulce', id: 'freshwaterQuality', icon: <WaterCheck /> },
  { label: 'Abundancia de especies nativas', id: 'nativeSpeciesAbundance', icon: <LocalFlorist /> },
  { label: 'Disponibilidad de agua dulce', id: 'freshwaterAvailability', icon: <Opacity /> },
];

const ConcernLevelsStateOfNature = ({ natureLevels }) => {
  const parsedConcernLevels = concernLevels.map(cl => ({ ...cl, segments: natureLevels ? generateSegments(natureLevels[cl.id]) : [] }));
  return (
    <Box mt={1}>
      <Typography variant="caption" color="textSecondary" gutterBottom>
        Nivel de preocupación por cada indicador con respecto al estado de la naturaleza
      </Typography>
      <Box pb={2} />
      <Box p={1}>
        <DiscreteProgressBarGroup items={parsedConcernLevels} />
      </Box>
    </Box>);
};

ConcernLevelsStateOfNature.propTypes = {
  natureLevels: PropTypes.object,
};

export {
  ConcernLevelsStateOfNature,
};
